import React from "react"
import { Navbar, Nav, Form, Button, Container } from "react-bootstrap"

const CustomNavbar = () => {
  return (
    <>
      <Navbar bg="light" expand="sm">
        <Container>
          <Navbar.Brand href="/saas-metrics">
            SaaS Metrics Calculators
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="mr-auto">
            </Nav>
            <Form inline>
              <Button href='http://eepurl.com/gTAek1' variant="outline-primary">Notify me about new models</Button>
            </Form>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  )
}

export default CustomNavbar
